var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDown2 = function SvgDown2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.276 6.572c.496.608.46 1.504-.107 2.071l-8.763 8.763a1.546 1.546 0 0 1-2.189 0L2.453 8.643a1.549 1.549 0 0 1 2.19-2.189l7.669 7.668 7.668-7.668a1.547 1.547 0 0 1 2.072-.106l.118.106.106.118z",
    fill: "#292A2C",
    fillRule: "evenodd"
  })));
};
export default SvgDown2;